module Meevo.Plugins.YieldManagementProgram {

    export enum ProgramAdjustmentOverrideEnum {
        SpecialPrice = 11045079,
        NoOverride = 11045080,
        IncreasePercent = 11045081,
        DecreasePercent = 11045082,
        IncreaseAmount = 11045083,
        DecreaseAmount = 11045084
    }

    export interface IDayTimeAdjustmentsRow {
        displayName: string;
        id: TrueWeekdayEnum;
        adjustments: ProgramTimeRange[];
    }

    export enum TrueWeekdayEnum {
        Sunday = 1,
        Monday = 2,
        Tuesday = 3,
        Wednesday = 4,
        Thursday = 5,
        Friday = 6,
        Saturday = 7,
    }
}
